import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { PredictionModel } from '~/utils/transforms/predictionModelsDataTransforms';
import { VersionChip } from '../Chip/VersionChip';

type ModelDetailsProps = {
    selectedModel: PredictionModel | undefined;
    selectedCustomization?: string;
    selectedStructures?: string[];
    roiNames?: string[];
};

export default function ModelParameters({
    selectedModel,
    selectedCustomization,
    selectedStructures,
    roiNames,
}: ModelDetailsProps) {
    return (
        <Box>
            {selectedModel && (
                <Box>
                    <Typography variant="body2" color="primary" fontSize={12}>
                        <FormattedMessage id="selectedModel" />:
                    </Typography>
                    <Box
                        display="grid"
                        gridTemplateColumns="1fr auto"
                        gap={1}
                        alignItems="center"
                        mr={2}
                    >
                        <Typography
                            fontSize={14}
                            sx={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                cursor: 'pointer',
                            }}
                        >
                            {selectedModel?.label}
                        </Typography>
                        {selectedModel.version && (
                            <VersionChip
                                version={selectedModel.version}
                                isLatest={selectedModel.isLatest}
                            />
                        )}
                    </Box>
                    {roiNames && selectedStructures && (
                        <Typography fontSize={12} color="textSecondary">
                            {selectedCustomization
                                ? `${selectedCustomization} with ${
                                      selectedStructures
                                          ? selectedStructures.length
                                          : 0
                                  } / ${roiNames.length} structures selected `
                                : `${
                                      selectedStructures
                                          ? selectedStructures.length
                                          : 0
                                  } / ${roiNames.length} structures selected `}
                        </Typography>
                    )}
                </Box>
            )}
        </Box>
    );
}
